import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/angielski';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-71" data-mp="e3dgfowuf8og">
      <div className="mx-auto max-w-6xl" data-id="element-72" data-mp="9vyg8jt240j">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-73" data-mp="58z6m1v30qcq">
          <div className="lg:col-span-7" data-id="element-74" data-mp="574gm94ye81s">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-75" data-mp="3mgugxw4z8jv3">Co zmienia ANGIELSKI GOTOWY™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-76" data-mp="3rhi7yht7h0pb">
              Od stresu przed lekcją do <em className="text-red-700" data-id="element-77" data-mp="3dir03d4xsb9m">spokoju i pewności.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-78" data-mp="3ihv6xx4e1wws">
            Wyobraź sobie, że zaczynasz tydzień z lekcjami angielskiego już zaplanowanymi. Wiesz, co będziesz
            prowadzić – i masz pod ręką scenariusze lekcji, karty rozmów, ćwiczenia, testy
            i materiały do oceniania.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-79" data-mp="1fad9z6114mbz">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-80" data-mp="1sznlkkxtx6e0" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-81" data-mp="10brr7mvqfqke">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-82" data-mp="wb7rqcnosav3">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-83" data-mp="1aba6hq0p6o64">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-84" data-mp="15bnt9gkvd7xb">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-85" data-mp="2lpntksnmmzl3">Bez pakietu ANGIELSKI GOTOWY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-86" data-mp="2gqjfpoprcdof">
              Czy to brzmi znajomo?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-87" data-mp="2oqpicioc8j6t">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-88" data-mp="2sux9emi9qb87">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-89" data-mp="2xq48ti4i8trb" />
                  <span data-id="element-90" data-mp="32onvxluu4bl9">
                    <span className="block font-semibold text-slate-900/80" data-id="element-91" data-mp="253ruc9k5jmyy">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-92" data-mp="2f0xnrog8nq2c">
            <p className="text-sm font-semibold text-red-300" data-id="element-93" data-mp="2jt7h7egkb89d">Z pakietem ANGIELSKI GOTOWY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-94" data-mp="1mdjsdus6v2kc">
              Mniej planowania. Więcej angielskiego.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-95" data-mp="1r9ie1am4u6h2">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-96" data-mp="1et9aa3q52tgq">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-97" data-mp="19u62ibiry952">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-98" data-mp="14vl3gff9dvi7" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-99" data-mp="w1q79ww47fep">
          Skup się na uczniach – a nie na samodzielnym tworzeniu wszystkich materiałów.
        </p>
      </div>
    </section>;
}